import { useRouteName } from '@hook/route/use-route-name.hook';

export const useApplicationSetup = () => {
  const name = useRouteName();

  return {
    name,
  };
};
